import { lazy } from 'react';

export const PracticeDashboardPage = lazy(() => import('./PracticeDashboardPage'));
